<template>
  <div>
    {{ title }}
    <v-btn icon @click="openDialog" v-if="$store.state.editable"><v-icon>mdi-pencil</v-icon></v-btn>
    <v-dialog v-model="dialog" max-width="400">
      <v-card :loading="loading">
        <v-card-title>
          제목 수정
          <v-spacer/>
          <v-btn @click="save" color="primary" text>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn icon text @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="setTitle"
            outlined
            label="제목"
            hide-details
            @keypress.enter="save"
            ></v-text-field>

        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer/>
          <v-btn @click="saveTitle" color="primary">
            <v-icon left>mdi-content-save</v-icon>
            저장
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ['title'],
  data () {
    return {
      loading: false,
      dialog: false,
      setTitle: ''
    }
  },
  methods: {
    openDialog () {
      this.dialog = true
      this.setTitle = this.title
    },
    async save () {
      try {
        this.loading = true
        const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : 'default'
        await this.$firebase.database().ref().child('sites').child(uid).update({
          title: this.setTitle
        })
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        this.dialog = false
        this.loading = false
      }
    }
  }
}
</script>
